// Em dev, sem REACT_APP_API_URL definido, usa o mesmo host que serviu a página
// (localhost, IP da rede local, etc.) em vez de fixar "localhost" — assim o app
// funciona tanto no PC quanto no celular acessando pelo IP, sem reconfiguração.
const DEV_HOST = `${window.location.protocol}//${window.location.hostname}:3001`;
const BASE_URL = process.env.REACT_APP_API_URL || `${DEV_HOST}/api`;

export function getUploadUrl(path) {
  if (!path) return null;
  const base = process.env.REACT_APP_UPLOADS_URL || `${DEV_HOST}/uploads`;
  return `${base}/${path}`;
}

function getToken() {
  return localStorage.getItem('token');
}

async function request(method, path, body, isFormData = false) {
  const headers = {};
  const token = getToken();
  if (token) headers['Authorization'] = `Bearer ${token}`;
  if (!isFormData) headers['Content-Type'] = 'application/json';

  const res = await fetch(`${BASE_URL}${path}`, {
    method,
    headers,
    body: isFormData ? body : (body ? JSON.stringify(body) : undefined),
  });

  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(data.error || 'Erro na requisição.');
  return data;
}

const api = {
  get: (path) => request('GET', path),
  post: (path, body) => request('POST', path, body),
  put: (path, body) => request('PUT', path, body),
  patch: (path, body) => request('PATCH', path, body),
  delete: (path) => request('DELETE', path),
  upload: (path, formData) => request('POST', path, formData, true),
  uploadPatch: (path, formData) => request('PATCH', path, formData, true),
  uploadPut: (path, formData) => request('PUT', path, formData, true),
};

export default api;
